/* eslint-disable no-param-reassign */
import {
  State, CurrentState, SelectingState,
} from '../menu-list.slice';
import { hasSelectedAll } from './helpers';

export default function toggleAll(state: State): void {
  if (state.current !== CurrentState.selecting) return;

  if (hasSelectedAll(state)) {
    state.selected = [];
    state.selectingState = SelectingState.simple;
  } else {
    state.selected = state.available;
    state.selectingState = SelectingState.allAvailable;
  }
}
